import type { ReactElement, ReactNode } from 'react';

/* An empty list, explained.
 *
 * `action` is not decoration. "No datasets" leaves a user stuck; "No datasets yet — register a
 * source and harvest it" tells them the next step, and an empty state without one is the most common
 * dead end in an admin product. The component makes the explanation a required prop so it cannot be
 * skipped in a hurry.
 *
 * Deliberately distinct from an error state. "There is nothing here" and "we could not find out
 * whether there is anything here" must never look the same — the second means retry, the first means
 * act. That distinction is the same one the PII review screen makes between `no PII found` and
 * `not assessed`, for the same reason.
 */

export interface EmptyStateProps {
  readonly title: string;
  /** What to do next. Required, because an empty state without it is a dead end. */
  readonly guidance: string;
  readonly action?: ReactNode;
}

export function EmptyState({ title, guidance, action }: EmptyStateProps): ReactElement {
  return (
    <div className="lq-empty">
      <p className="lq-empty__title">{title}</p>
      <p className="lq-empty__guidance">{guidance}</p>
      {action}
    </div>
  );
}
